import axios from 'axios'

let meDefaults = {
  tokenUser: {
    id: null,
    kvcoresso: null,
    company: {
      name: '',
      hasMembershipLicenses: false,
      offices: [],
      flags: {
        SHOW_MANAGE_SHORT_CODES_PAGE: null
      },
      preferences:{}
    },
    office: {
      flags: {},
      hasMembershipLicenses: false
    },
    email: "",
    name: "",
    loggedInAs: '',
    product: "",
    realtorid: "",
    isCompanyAdmin: false,
    isOfficeAdmin: false,
    preferences:{}
  },
  isImpersonated: null,
  impersonated: {
    id: "",
    name: "",
    loggedInAs: ''

  }
}


const state = {
  me: {
    ...meDefaults
  }
}
const getters = {
  me: (state) => {
    return state.me
  },
  isTokenUserAnyAdmin: (state) => {
    return state.me.tokenUser.isCompanyAdmin || state.me.tokenUser.isOfficeAdmin;
  },
  officeAdmin() {
    return !!(state.me.tokenUser.isCompanyAdmin && (state.me.isImpersonated && state.me.impersonated.loggedInAs === 'office') || state.me.tokenUser.isOfficeAdmin);
  },
}
const actions = {
  async fetchMe({commit}) {
    const response = await axios.get(`me`)
    commit('setMe', response.data)
  }

}
const mutations = {
  setMe: (state, me) => (state.me = me)
}

export default {
  state,
  getters,
  actions,
  mutations
}